import siteCookie from '../utils/siteCookie';
import trackingEvents from './_trackingEvents';

const CAMPAIGN_KEYS = [
  'campaign_code',
];

const eventName = trackingEvents.USER_PARTICIPATED;

// 元々はmixpanelのイベントをトラッキングしていた
// siteCookieが何をしているかはわからないので、そのロジックだけ残している
// FIXME: 不要だったらこのファイルは削除、必要ならメソッド名を変更
export default function trackRegistrationCompleted() {
  CAMPAIGN_KEYS.forEach((key) => {
    const ck = siteCookie.get(key);
    if (ck) {
      siteCookie.erase(key);
    }
  });
}
